<template>
  <div>
    <ais-configure :hits-per-page.camel="20" />
    <ais-hits
      :class-names="{
        'ais-Hits-list': 'list-unstyled row row-cols-1 row-cols-md-2 g-3',
        'ais-Hits-item': 'col',
        }">
        <template v-slot:item="{ item }">
          <SearchResultCard :offer="item" />
        </template>
      </ais-hits>
    </div>
</template>

<script>
import { AisConfigure, AisHits } from 'vue-instantsearch/vue3/es';
import SearchResultCard from './search_result_card.vue';

export default {
  name: 'SearchResults',
  components: {
    AisConfigure,
    AisHits,
    SearchResultCard,
  },
};
</script>
